import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getFollowing = createAction(
  'GET_FOLLOWING',
  currentUser => api.get(`followers/${currentUser}`).setCritical(false)
);

export const followUser = createAction(
  'FOLLOW_USER',
  userId => api.post('followers', userId),
  userId => ({ userId })
);

export const unfollowUser = createAction(
  'UNFOLLOW_USER',
  ({ relationshipId }) => api.delete(`followers/${relationshipId}`),
  ({ userId }) => ({ userId })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/follow.js